import { FlexCol, FlexRow } from '@/components/common/Flex';
import { hoverStyleProps } from '@/components/common/styleHelpers';
import { FlexProps } from '@chakra-ui/react';
import { dt } from '@common/util/dateTime';
import { FC } from 'react';
import { Text } from '../common/Typography';

export interface ActivityRowProps extends FlexProps {
    dateTime: string;
    leftTextColor?: string;
    leftText: string | React.ReactNode;
    rightText?: string | React.ReactNode;
    icon: JSX.Element;
    onClick?: VoidFunction;
}

const ActivityRow: FC<ActivityRowProps> = ({
    dateTime,
    leftText,
    leftTextColor,
    rightText,
    icon,
    onClick,
    ...props
}) => {
    return (
        <FlexRow
            my={1}
            py={4}
            px={1}
            borderRadius={3}
            justify="space-between"
            align="flex-start"
            onClick={onClick}
            cursor={onClick && 'pointer'}
            {...(onClick
                ? hoverStyleProps({
                      bg: 'white',
                      boxShadow: '0 0 0 8px white',
                  })
                : {})}
            {...props}
        >
            <FlexRow align="center">
                {icon}
                <FlexCol ml={3} gap={0.5}>
                    <Text
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        maxW={96}
                        color={leftTextColor}
                    >
                        {leftText}
                    </Text>
                    <Text color="textMuted" fontSize="sm" ml={0.5}>
                        {getWhenStr(dateTime)}
                    </Text>
                </FlexCol>
            </FlexRow>
            {rightText && (
                <FlexCol alignItems="flex-end" minW={16}>
                    <Text>{rightText}</Text>
                </FlexCol>
            )}
        </FlexRow>
    );
};

const getWhenStr = (createdAt: string) => {
    const createdAtDT = dt(createdAt);
    return createdAtDT.isBefore(formatCutoffDT)
        ? createdAtDT.format('MMM DD, YYYY')
        : createdAtDT.fromNow();
};

const formatCutoffDT = dt().startOf('day').subtract(2, 'days');

export default ActivityRow;
